import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { useApiClient } from '@/context/ApiClientContext/useApiClient.ts';
import useAutomationId from '@/hooks/useAutomationId.ts';
import { AUTOMATION_LLM_USAGE_KEY } from '@/utils/queryKeys.ts';
import { get_automation_llm_usage_url } from '@/utils/urls.ts';
import { LlmUsageSummary } from '@/types/llmUsage.ts';

const useRetrieveAutomationLlmUsage = (
  automationId?: string,
  enabled = true,
): UseQueryResult<LlmUsageSummary, AxiosError> => {
  const apiClient = useApiClient();
  const automationIdFromURL = useAutomationId();

  const currentAutomationId = automationId || automationIdFromURL;

  return useQuery({
    queryKey: AUTOMATION_LLM_USAGE_KEY(currentAutomationId),
    queryFn: async () => {
      const response = await apiClient.get<LlmUsageSummary>(
        get_automation_llm_usage_url(currentAutomationId),
      );
      return response.data;
    },
    enabled: !!currentAutomationId && enabled,
  });
};

export default useRetrieveAutomationLlmUsage;
